/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-components';
import type { JSXElement } from '@fluentui/react-utilities';
import type { GroundingCommandBarState, GroundingCommandBarSlots } from './GroundingCommandBar.types';

/**
 * Render the final JSX of GroundingCommandBar
 */
export const renderGroundingCommandBar_unstable = (state: GroundingCommandBarState): JSXElement => {
  assertSlots<GroundingCommandBarSlots>(state);

  return <state.root />;
};
